export default __webpack_public_path__ + "static/media/samantha_marcus_modal.4a9afaad.png";